import React, {Children, useState} from "react";
import BringzzText from "../BringzzText";
import BringzzIcon from "../BringzzIcon";
import BringzzBottomDrawer from "../BringzzBottomDrawer";

import classNames from "classnames";
import BringzzPostingCardAction from "./BringzzPostingCardAction"
import PropTypes from 'prop-types';
import {BringzzButton, BringzzImage, BringzzInput} from "../../index";
import BringzzListItem from "../BringzzList/BringzzListItem";

const BringzzPostingCard = ({
                               uuid,
                               className,
                               avatar,
                               name,
                               header,
                               likesCount,
                               commentsCount,
                               action,
                               title,
                               description,
                               sponsored = false,
                               defaultMode = "compact", // compact | expanded
                               children,
                               bookmarks,
                               isPreview = false,
                               handleBookmarkClick,
                               hasBookmark,
                               addBookmark,
                               deleteBookmark,
                               collections,
                               CollectionCreationDrawer,
                               createCollection,
                               isLiked,
                               ...props
                           }) => {

   const [expanded, setExpanded] = useState(defaultMode === 'expanded')


   const toggleMode = () => {
       setExpanded(!expanded)
   }



   /*
    <BringzzList type="bookmarks" items={bookmarks} fixed={false}
                            handleBookmarkClick={handleBookmarkClick}></BringzzList>
    */
   return (
       <>


           <div className={classNames("border-b border-sand", className)}>
               <div className="flex justify-between items-center py-2 px-4">
                   <div className="flex items-center space-x-1">
                   <img src={avatar} className="h-6 w-6 rounded-full" alt="avatar"/>
                       <BringzzText
                           tag="h5"
                           className={"font-bold"}
                       >
                           {name}
                       </BringzzText>
                       {sponsored && <div className="flex items-center space-x-1">
                           <span className="text-[5px]">&#9679;</span>
                           <BringzzText
                               tag="h5"
                               className={'font-normal'}
                           >
                               Sponsored
                           </BringzzText>
                       </div>}
                   </div>
                   {/* <div className="flex space-x-[1px] items-center cursor-pointer">
                       <span className="text-[5px]">&#9679;</span>
                       <span className="text-[5px]">&#9679;</span>
                       <span className="text-[5px]">&#9679;</span>
                   </div> */}
               </div>
               <div className="relative">
                   {header}

                   {!expanded && <div className="absolute bottom-0 w-full px-4 pb-6 xl:px-6">
                       <BringzzPostingCardAction action={action}></BringzzPostingCardAction>
                   </div>}
               </div>

               <div className="px-4 xl:px-6">
                   <div className=" py-2 ">
                       <BringzzText
                           tag="h4"
                           className={"font-bold"}
                       >
                           {title}
                       </BringzzText>
                       <BringzzText
                           tag="h4"
                           className={classNames("font-normal", children ? "cursor-pointer" : '')}
                           onClick={children && toggleMode}
                       >
                           {description}
                           {expanded && <><br></br><span className="underline">show less</span></>}
                       </BringzzText>
                       {expanded && <>
                           {children}
                           <BringzzPostingCardAction action={action}></BringzzPostingCardAction>
                       </>}
                   </div>
                   <div className="flex h-14 items-center justify-between ">
                       <div className="flex items-center space-x-4">
                           <BringzzIcon
                               icon={isLiked ? "IconHeartFill" : "IconHeartCopy"}
                               folder={"LineIcons"}
                               size="20"
                               className={`cursor-pointer ${isLiked ? 'text-red-600' : ''}`}
                               onClick={props.onLikeClick}
                           ></BringzzIcon>
                           {likesCount > 0 && (
                               <BringzzText className="text-xs text-gray-500">
                                   {likesCount}
                               </BringzzText>
                           )}
                           <BringzzIcon
                               icon="IconChatAlt6"
                               folder="LineIcons"
                               size="20"
                               className="cursor-pointer"
                               onClick={() => props.onCommentClick && props.onCommentClick()}
                           ></BringzzIcon>
                           {!isNaN(commentsCount) && commentsCount > 0 && (
                               <BringzzText className="text-xs text-gray-500">
                                   {commentsCount}
                               </BringzzText>
                           )}
                           <BringzzIcon
                               icon={hasBookmark ? "IconBookmarkSolid" : "IconBookmark"}
                               folder="HeroIcons"
                               size="20"
                               className={`cursor-pointer ${hasBookmark ? 'text-gold' : ''}`}
                               onClick={() => {
                                   if (isPreview) return;
                                   if (hasBookmark) {
                                       deleteBookmark();
                                   } else {
                                       addBookmark();
                                   }
                               }}
                           ></BringzzIcon>
                       </div>
                       <BringzzIcon
                           icon="IconUploadAlt"
                           folder="LineIcons"
                           className="cursor-pointer"
                           size="20"
                           onClick={props.onCopyPostUrl}
                       ></BringzzIcon>
                   </div>
               </div>
           </div>
       </>
   );
};

BringzzPostingCard.propTypes = {
   className: PropTypes.string,
   avatar: PropTypes.string.isRequired,
   name: PropTypes.string.isRequired,
   header: PropTypes.node.isRequired,
   likesCount: PropTypes.number,
   commentsCount: PropTypes.number,
   sponsored: PropTypes.bool,
   action: PropTypes.shape({
       icon: PropTypes.string.isRequired,
       iconFolder: PropTypes.string,
       label: PropTypes.string.isRequired,
       onClick: PropTypes.func,
   }).isRequired,
   title: PropTypes.string.isRequired,
   // bookmarks: PropTypes.string.isRequired,
   isPreview: PropTypes.bool,
   description: PropTypes.string.isRequired,
   defaultMode: PropTypes.oneOf(['compact', 'expanded']),
   children: PropTypes.node,
   collections: PropTypes.array,
   addBookmark:PropTypes.func,
   deleteBookmark:PropTypes.func,
   CollectionCreationDrawer: PropTypes.elementType,
   onCommentClick: PropTypes.func,
   commentsCount: PropTypes.number,
   isLiked: PropTypes.bool,
   onLikeClick: PropTypes.func,
   onCopyPostUrl: PropTypes.func,
};


export default BringzzPostingCard;
